var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToolbarAgent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16,8.16A4.1,4.1,0,1,1,12,12.31v-.1A4.07,4.07,0,0,1,16,8.16Zm6.29,2.42a.76.76,0,0,1,.78.75v1.75a.78.78,0,0,1-.78.77h-.95a.77.77,0,0,1-.77-.77h0V11.35a1,1,0,0,1,.51-.77.11.11,0,0,0,.1-.1h0A5.45,5.45,0,0,0,16,6.78a5.58,5.58,0,0,0-5.17,3.7c0,.18.09.1.25.18a.68.68,0,0,1,.44.69v1.73a.83.83,0,0,1-.6.77c-.09.08,0,.17,0,.26a5.27,5.27,0,0,0,3.53,3.33c.43.09.18-.43.95-.43h1.43a.66.66,0,0,1,.61.69v.61a.58.58,0,0,1-.58.6H15.41c-.35,0-.61-.08-.69-.43a.45.45,0,0,0-.43-.26,6.53,6.53,0,0,1-4.17-4c-.09-.17-.09-.34-.35-.34l-.08-.08a.78.78,0,0,1-.78-.78h0v-1.7a.82.82,0,0,1,.83-.77c.1,0,.26,0,.26-.18A6.31,6.31,0,0,1,16,6,6.14,6.14,0,0,1,22,10.39.47.47,0,0,0,22.3,10.58ZM18.77,17c.17-.42.6-.42,1-.25a5.37,5.37,0,0,1,3.34,2.59,3,3,0,0,1,.43,1.71v4.49c0,.35,0,.43-.43.43H8.94c-.43,0-.51-.08-.51-.52,0-1.29.08-2.67,0-4a4.92,4.92,0,0,1,2-3.85.62.62,0,0,1,.43-.18c.17,0,.17.09.35.18,1.29,1,6.8,4.16,7.4.51A1.78,1.78,0,0,1,18.77,17Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolbarAgent);
export default __webpack_public_path__ + "static/media/toolbar-agent.d0a558e8.svg";
export { ForwardRef as ReactComponent };